import { useState } from "react";
import { ChevronDown, History as HistoryIcon } from "lucide-react";
import StatusHistoryList from "@/components/StatusHistoryList";

// Collapsible "Movimientos del viaje" block at the bottom of the edit form.
export default function TripMovementsSection({ history, loading }) {
  const [open, setOpen] = useState(false);
  const count = Array.isArray(history) ? history.length : 0;
  return (
    <div className="rounded-md border border-border bg-secondary/20" data-testid="trip-movements-section">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        data-testid="trip-movements-toggle"
        className="w-full flex items-center justify-between px-3 py-2 text-left hover:bg-secondary/40 transition-colors rounded-md"
      >
        <span className="flex items-center gap-2 text-xs font-mono tracking-widest text-muted-foreground">
          <HistoryIcon className="w-3.5 h-3.5" /> MOVIMIENTOS DEL VIAJE
          <span className="text-[10px] px-1.5 py-0.5 rounded bg-secondary text-white/80 tabular-nums" data-testid="trip-movements-count">{count}</span>
        </span>
        <ChevronDown className={`w-4 h-4 text-muted-foreground transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="px-2 pb-2 max-h-72 overflow-y-auto" data-testid="trip-movements-body">
          <StatusHistoryList history={history} loading={loading} testId="trip-movements-list" />
        </div>
      )}
    </div>
  );
}
